export const TRAINING_USERS_DOMAIN = 'trainingUsers'
export const TRAINING_USERS_ACTION = {
  CREATE_AFTER_LOG_IN: 'TRAINING_USERS_CREATE_AFTER_LOG_IN',
  DELETE_ACCOUNT: 'TRAINING_USERS_DELETE_ACCOUNT',
  START_FREE_TRIAL: 'TRAINING_USERS_START_FREE_TRIAL',
  CANCEL_SUBSCRIPTION: 'TRAINING_USERS_CANCEL_SUBSCRIPTION',
  EXTEND_FREE_TRIAL: 'TRAINING_USERS_EXTEND_FREE_TRIAL',
  APPLY_DISCOUNT_COUPON: 'TRAINING_USERS_APPLY_DISCOUNT_COUPON',
  UPDATE_SUBSCRIPTION: 'TRAINING_USERS_UPDATE_SUBSCRIPTION',
  SUBSCRIBE_TO_PREMIUM: 'TRAINING_USERS_SUBSCRIBE_TO_PREMIUM',
  UPDATE_SOURCE: 'TRAINING_USERS_UPDATE_SOURCE',
  LOAD_PROFILES: 'TRAINING_USERS_LOAD_PROFILES',
  LOAD_CURRENT: 'TRAINING_USERS_LOAD_CURRENT',
  UPDATE_CURRENT: 'TRAINING_USERS_UPDATE_CURRENT',
  DELETE_CURRENT: 'TRAINING_USERS_DELETE_CURRENT'
}

export const TRAINING_USERS_ENDPOINT = {
  ROOT: '/users',
  BY_ID: '/users/:id',
  SEND_VERIFICATION_EMAIL_BY_ID: '/users/:id/send-verification-email',
  GET_PROFILES: '/users/profiles',
  UPDATE_SOURCE: '/users/update-source',
  CANCEL_SUBSCRIPTION_BY_ID: '/users/:id/subscriptions/:subscriptionId/cancel',
  EXTEND_FREE_TRIAL_SUBSCRIPTION_BY_ID: '/users/:id/subscriptions/:subscriptionId/extend-free-trial',
  APPLY_DISCOUNT_COUPON: '/users/:id/subscriptions/:subscriptionId/apply-discount-coupon',
  UPDATE_SUBSCRIPTION_BY_ID: '/users/:id/subscriptions/:subscriptionId',
  SUBSCRIBE_TO_PLAN: '/users/subscribe-to-plan'
}

export const TRAINING_USERS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data',
  NEW_CUSTOMER_DISCOUNT_EXPIRES_AT: 'newCustomerDiscountExpiresAt'
}

export const TRAINING_USERS_PATH = {
  ALL: `${TRAINING_USERS_DOMAIN}.${TRAINING_USERS_KEY.ALL}`,
  CURRENT: `${TRAINING_USERS_DOMAIN}.${TRAINING_USERS_KEY.CURRENT}`,
  DATA: `${TRAINING_USERS_DOMAIN}.${TRAINING_USERS_KEY.DATA}`,
  NEW_CUSTOMER_DISCOUNT_EXPIRES_AT: `${TRAINING_USERS_DOMAIN}.${TRAINING_USERS_KEY.NEW_CUSTOMER_DISCOUNT_EXPIRES_AT}`
}

export const TRAINING_USERS_STATE = {
  [TRAINING_USERS_KEY.ALL]: {
    data: [],
    status: null
  },
  [TRAINING_USERS_KEY.CURRENT]: null,
  [TRAINING_USERS_KEY.DATA]: {},
  [TRAINING_USERS_KEY.NEW_CUSTOMER_DISCOUNT_EXPIRES_AT]: null
}

export const TRAINING_USERS_ANALYTIC_EVENT = {
  ACCOUNT_DELETED: 'Training Users Account Deleted',
  FREE_TRIAL_STARTED: 'Training Users Free Trial Started',
  COACHING_FREE_TRIAL_STARTED: 'Training Users Coaching Free Trial Started',
  CANCEL_SUBSCRIPTION: 'Training Users Subscription Canceled',
  JOIN_CHALLENGE_SUBSCRIPTION_CLICKED: 'Training Users Subscription Canceled'
}

export const TRAINING_USERS_ACTIONS_EVENT_CATEGORY = 'Training Users Actions'

export const TRAINING_USER_LOCAL_STORAGE_KEY = {
  NEW_CUSTOMER_DISCOUNT_EXPIRES_AT: 'newCustomerDiscountExpiresAt'
}
